export default "__VITE_ASSET__DHmPhuhg__"